import {async} from "q";
import axiosClient from "./axiosClient";

let serviceURL = "search";
const SearchPatientService = {
  getImageSrc: imageId => {
    const url = `/search/upload-images?imageId=${imageId}`;
    return axiosClient.getUri() + url;
  },
  getHistoriesByIdPK: async params => {
    const url = serviceURL + `/lich-su-kham-benh`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getListPatient: async params => {
    const url = serviceURL + `/benh-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  createNewPatient: async params => {
    const url = serviceURL + `/benh-nhan`;
    const response = await axiosClient.post(url, {
      params: params,
    });
    return response;
  },

  updatePatient: async params => {
    const url = serviceURL + `/benh-nhan`;
    const response = await axiosClient.put(url, {
      params: params,
    });
    return response;
  },
  deletePatient: async params => {
    const url = serviceURL + `/benh-nhan`;
    const response = await axiosClient.delete(url, {
      params: params,
    });
    return response;
  },
  getListMedicalBill: async params => {
    const url = serviceURL + `/phieu-kham/list-phieu-kham-da-tiep-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  postMedicalBill: async params => {
    const url = serviceURL + `/phieu-kham`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  putMedicalBill: async params => {
    const url = serviceURL + `/phieu-kham?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response;
  },
  updatePhieuKhamNgoaiTru: async params => {
    const url = serviceURL + `/phieu-kham-ngoai-tru?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response;
  },
  deleteMedicalBill: async params => {
    const url = serviceURL + `/phieu-kham`;
    const response = await axiosClient.delete(url, {
      params: params,
    });
    return response;
  },
  getListApplicablePolicy: async params => {
    const url =
      serviceURL +
      `/dm-chinh-sach-bhyt/list-dm-chinh-sach-bhyt?page=${params.page}&limit=${params.limit}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getImage: async params => {
    const url = serviceURL + `/upload-images`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  uploadImage: async formData => {
    const url = serviceURL + `/upload-images`;
    const response = await axiosClient.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response;
  },
  getListPatientCard: async params => {
    const url = serviceURL + `/don-ban-the-kham/paging-chi-tiet`;
    return await axiosClient.get(url, {
      params: params,
    });
  },
  postExtendCard: async params => {
    const url = serviceURL + `/the-benh-nhan`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  extendCard: async params => {
    const url = serviceURL + `/the-benh-nhan?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response;
  },
  deletePatientCard: async params => {
    const url = serviceURL + `/don-ban-the-kham/chi-tiet`;
    const response = await axiosClient.delete(url, {
      params: params,
    });
    return response;
  },
  getExtendCardInfo: async params => {
    const url = serviceURL + `/the-benh-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  generateMBN: async params => {
    const url = serviceURL + `/benh-nhan/sinh-ma-benh-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  generateMPK: async params => {
    const url = serviceURL + `/phieu-kham/sinh-ma-phieu-kham`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  getListExamServiceCategory: async () => {
    const url = serviceURL + `/dm-dich-vu/list-dm-dich-vu-kham`;
    const response = await axiosClient.get(url);
    return response;
  },
  getListRoomCategory: async () => {
    const url = serviceURL + `/dm-phong/list-dm-phong`;
    const response = await axiosClient.get(url);
    return response;
  },
  getRoomById: async params => {
    const url = serviceURL + `/dm-phong`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  getListPatientWaiter: async () => {
    const url = serviceURL + `/phieu-kham/get-so-benh-nhan-cho-kham`;
    const response = await axiosClient.get(url);
    return response;
  },
  updateStatus: async params => {
    const url =
      serviceURL +
      `/phieu-kham/cap-nhat-trang-thai?id=${params.id}&trangThai=${params.trangThai}`;
    const response = await axiosClient.put(url);
    return response;
  },
  getDiagnosticByIdExamination: async params => {
    const url =
      serviceURL +
      `/chuan-doan/lay-bang-ma-phieu-kham-ngoai-tru?idPhieuKhamNgoaiTru=${params.id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getNextPatient: async () => {
    const url = serviceURL + `/phieu-kham-ngoai-tru/benh-nhan-tiep-theo`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  createDiagnostic: async params => {
    const url = serviceURL + `/chuan-doan`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  updateDiagnostic: async (params, id) => {
    const url = serviceURL + `/chuan-doan?id=${id}`;
    const response = await axiosClient.put(url, params);
    return response;
  },
  getListObjects: async () => {
    const url = serviceURL + `/dm-doi-tuong/list-dm-doi-tuong`;
    const response = await axiosClient.get(url);
    return response;
  },
  getObjectById: async params => {
    const url = serviceURL + `/dm-doi-tuong`;
    const response = await axiosClient.get(url, {params: params});
    return response;
  },
  getSourcePatient: async () => {
    const url = serviceURL + `/dm-nguon-benh-nhan/list-dm-nguon-benh-nhan`;
    const response = await axiosClient.get(url);
    return response;
  },
  getTypeIOL: async id => {
    const url = `/store/VTYT/searchKey`;
    const params = {nhomVTYTId: id};
    const response = await axiosClient.get(url, {params: params});
    return response;
  },
  getListLoaiKCB: async () => {
    const url = serviceURL + `/dm-loai-kcb/list-dm-loai-kcb`;
    const response = await axiosClient.get(url);
    return response;
  },
  postPatient: async params => {
    const url = serviceURL + `/benh-nhan`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  putPatient: async params => {
    const url = serviceURL + `/benh-nhan?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response;
  },
  getListRelation: async () => {
    const url = serviceURL + `/dm-quan-he/list-dm-quan-he`;
    const response = await axiosClient.get(url);
    return response;
  },
  getIcdList: async () => {
    const url = serviceURL + `/dm-icd/list-dm-icd`;
    const response = await axiosClient.get(url);
    return response;
  },
  getIcd10List: async id => {
    const url = serviceURL + `/dm-icd-10/list-dm-icd-10?idIcd=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  postConclude: async params => {
    const url = serviceURL + `/ket-luan`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  getConcludeByIdExam: async params => {
    const url = serviceURL + `/ket-luan/get-by-phieu-kham`;
    const response = await axiosClient.get(url, {params: params});
    return response;
  },
  postPrescription: async params => {
    const url = serviceURL + `/don-thuoc`;
    const response = await axiosClient.post(url, params);
    return response;
  },
  getPrescriptionById: async id => {
    const url = serviceURL + `/don-thuoc?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getPrescriptionsByExamId: async id => {
    const url =
      serviceURL +
      `/don-thuoc/list-don-thuoc-by-id-phieu-kham-ngoai-tru?idPhieuKhamNgoaiTru=${id}`;
    const response = await axiosClient.get(url);
  },
  getPatientById: async params => {
    const url = serviceURL + `/benh-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  getPatientByMaBN: async params => {
    const url = serviceURL + `/benh-nhan/lay-bang-ma-benh-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },

  getPKInById: async params => {
    const url = serviceURL + `/phieu-kham-in`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  getPKById: async id => {
    const url = serviceURL + `/phieu-kham?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getPKNTById: async params => {
    const url = serviceURL + `/phieu-kham-ngoai-tru`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getPKNTAllById: async params => {
    const url = serviceURL + `/phieu-kham-ngoai-tru-in`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  getPatientCardById: async params => {
    const url = serviceURL + `/the-benh-nhan/get-by-ma-benh-nhan`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response;
  },
  updatePatientCardStatusById: async params => {
    const url =
      serviceURL +
      `/the-benh-nhan/cap-nhat-trang-thai?id=${params.id}&trangThaiThe=${params.trangThaiThe}`;
    const response = await axiosClient.put(url);
    return response;
  },
  getListPKNT: async params => {
    const url = serviceURL + `/phieu-kham-ngoai-tru/list-phieu-kham-ngoai-tru`;
    const response = await axiosClient.get(url, {params: params});
    return response;
  },
  getListTTPhieuKham: async params => {
    const url =
      serviceURL + `/dm-trang-thai-phieu-kham/list-dm-trang-thai-phieu-kham`;
    const response = await axiosClient.get(url, {params: params});
    return response;
  },
  getListKhuKham: async () => {
    const url = `/qlkhambenh/dm-khu-kham/list-dm-khu-kham`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTrangThaiBH: async () => {
    const url = `/qlkhambenh/dm-trang-thai-bh/list-dm-trang-thai-bh`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTrangThaiPhieuKham: async () => {
    const url = `/qlkhambenh/dm-trang-thai-phieu-kham/list-dm-trang-thai-phieu-kham`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getListTrangThaiThe: async () => {
    const url = `/qlkhambenh/dm-trang-thai-the-bn/list-dm-trang-thai-the-bn`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  hoanThanhKhaiBao: async id => {
    const url =
      serviceURL + `/phieu-kham/hoan-thanh-khai-bao?idPhieuKham=${id}`;
    const response = await axiosClient.post(url);
    return response;
  },
  postKetLuan: async params => {
    let url = serviceURL + `/ket-luan`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putKetLuan: async params => {
    let url = serviceURL + `/ket-luan?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getKetLuanByIdPKNT: async params => {
    let url = serviceURL + `/ket-luan/get-by-phieu-kham-ngoai-tru`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  postDonThuoc: async params => {
    let url = serviceURL + `/don-thuoc`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDonThuoc: async params => {
    let url = serviceURL + `/don-thuoc?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  postDonThuocPhu: async params => {
    let url = serviceURL + `/don-thuoc-phu`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putDonThuocPhu: async params => {
    let url = serviceURL + `/don-thuoc-phu?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  getDonThuocByIdPKNT: async params => {
    let url =
      serviceURL + `/don-thuoc/list-don-thuoc-by-id-phieu-kham-ngoai-tru`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDonThuocPhuByIdPKNT: async params => {
    let url =
      serviceURL +
      `/don-thuoc-phu/list-don-thuoc-phu-by-id-phieu-kham-ngoai-tru`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDonBanTheKhamByIdBenhNhan: async params => {
    let url = serviceURL + `/don-ban-the-kham/chi-tiet-by-benh-nhan`;
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDataPrintXN: async id => {
    const url = `/search/phieu-xet-nghiem-in?id=${id}`;
    const response = await axiosClient.get(url);
    return response;
  },
  getDetailConsultantAndFragmentById: async id => {
    const url = `/search/phieu-tu-van?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getDetailsDiagnoseById: async id => {
    const url = `/search/phieu-cdha/chi-tiet-cdha?idPhieuCDHA=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getDetailPrintElectro: async id => {
    const url = `/search/phieu-dien-tim-in?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
  getNurseForm: async id => {
    const url = "/search/phieu-dieu-duong";
    const params = {id: id};
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getListLichsuTraThuoc: async id => {
    const url = `/search/tra-thuoc/lich-su-tra-thuoc`;
    const params = {idPhieuDieuDuong: id};
    const response = await axiosClient.get(url, {params: params});
    return response.data;
  },
  getDetailReceivedById: async id => {
    const url = `/search/refraction/id?id=${id}`;
    const response = await axiosClient.get(url);
    return response.data;
  },
};

export default SearchPatientService;
